import { SurveyFormatRef, PayloadActionCreator, SurveyFormatType, ActionPayloadType } from './types';
import { SurveyAction } from './constants';

export type RegisterAction = PayloadActionCreator<typeof SurveyAction.REGISTER, SurveyFormatRef>;
export const register: RegisterAction = ref => ({
  type: SurveyAction.REGISTER,
  payload: ref,
});

export type UnRegisterAction = PayloadActionCreator<typeof SurveyAction.UNREGISTER, SurveyFormatRef['name']>;
export const unregister: UnRegisterAction = name => ({
  type: SurveyAction.UNREGISTER,
  payload: name,
});

export type SetActiveAction = PayloadActionCreator<typeof SurveyAction.SET_ACTIVE, SurveyFormatRef['name'] | null>;
export const setActive: SetActiveAction = name => ({
  type: SurveyAction.SET_ACTIVE,
  payload: name,
});

export type SetFormatAction = PayloadActionCreator<typeof SurveyAction.SET_FORMAT, SurveyFormatType>;
export const setFormat: SetFormatAction = format => ({
  type: SurveyAction.SET_FORMAT,
  payload: format,
});

/** Discriminate Union of all Actions  */
export type Actions = RegisterAction | UnRegisterAction | SetActiveAction | SetFormatAction;

/** All possible `PayloadAction` */
export type SurveyPayloadAction = ActionPayloadType<Actions>;
